import { createRouter, createWebHistory } from 'vue-router'
import axios from "axios";
import common_config from "@/configs/common";
import auth_config from "@/configs/auth";
import RouteAuth from '@/router/route/auth/'
import RouteCommon from '@/router/route/common/'
import RoutePortal from '@/router/route/portal/'
import RouteTest from '@/router/route/test/'
import Error from '@/components/error/notfound/IndexErrorNotFound';

const routes =
  [
    ...RouteAuth,
    ...RouteCommon,
    ...RoutePortal,
    ...RouteTest,
    { path: '/:catchAll(.*)', component: Error }
  ]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
})

router.beforeEach(async (to) => {
  const storeAuth = require('@/helpers/store/storeAuthHelper')
  const storeActivate = require('@/helpers/store/storeActivateHelper')
  const storeSystem = require('@/helpers/store/storeSystemHelper')
  const { isEnvProd } = require('@/helpers/environment')

  storeSystem.storeSetRoute(to)
  storeSystem.storeSetRouter(router)

  // テストページは本番利用不可
  if (!to.path.indexOf("/test/") && isEnvProd()) {
    window.location = "/notfound"
    return false
  }
  if (!to.path.indexOf("/apptest/") && isEnvProd()) {
    window.location = "/notfound"
    return false
  }

  // 認証チェック不可ページ
  if (!to.path.indexOf("/redirect/")) return
  if (!to.path.indexOf("/receive")) return
  if (!to.path.indexOf("/notfound")) return

  // ソースバージョンチェック
  const local_ver = common_config.source_version;
  const res = await axios.create({ "Cache-Control": "no-store" }).get("/source_version")
  if (res.status == 200) {
    const new_version = res.data
    if (new_version != local_ver) {
      // サーバのソースバージョンが更新されている場合は、リロードしてソース再読込
      window.location.assign(to.fullPath)
      return
    }
  }

  // 認証チェック不可ページ
  if (!to.path.indexOf("/auth/")) return

  // 招待コード一時保存
  if (to.query.ivc != undefined) {
    if (to.query.qr != undefined) {
      if (window.confirm("アプリを起動しますか？")) {
        // TODO:現状ちゃんと動かない
        let url = auth_config.application + "://"
        window.location = url
        return false;
      } else {
        storeActivate.storeSetActivateInviteCode(to.query.ivc)
      }
    } else {
      storeActivate.storeSetActivateInviteCode(to.query.ivc)
    }
  }

  // 外部認証ログイン時
  if (
    to.query.code != undefined &&
    to.query.state != undefined
  ) {
    window.location = "/auth/external/confirm?code=" + to.query.code + "&state=" + to.query.state
    return false;
  }

  // 外部認証ログインエラー時
  if (
    to.query.error_description != undefined &&
    to.query.state != undefined &&
    to.query.error != undefined
  ) {
    window.location = "/auth/external/confirm?error_description=" + to.query.error_description + "&state=" + to.query.state + "&error=" + to.query.error
    return false;
  }

  // アプリサインイン時  
  if (to.query.token != undefined) {
    window.location = "/auth/savetoken?token=" + to.query.token + "&sys=" + to.query.sys
    return false;
  }

  // ログイン中
  if (storeAuth.storeIsExistIdToken()) {
    // 招待時
    if (to.query.ivc != undefined) {
      window.location = "/setup/invite"
      return false;
    }

    // 初期設定画面やエラー系以外ならチェック処理
    if (to.path.indexOf("/setup") && to.path.indexOf("/notfound") && to.path.indexOf("/noshop")) {

      // プロファイル状態チェック
      const errmsg = storeAuth.storeGetProfileError()
      const associate = storeAuth.storeGetSelectedAssociate()
      if (errmsg) {
        if (errmsg == 'account not found.') {
          window.location = "/setup/account"
          return false
        } else {
          window.location = "/auth/signout"
          return false
        }
      } else if (storeAuth.storeGetAccount() && !associate) {
        // アカウントはあるけど、企業がない場合もアカウント初期画面へ
        window.location = "/setup/account"
        return false
      } else if (Object.keys(associate.staff).length == 0) {
        window.location = "/noshop"
        return false
      }
    }
  } else {
    // 未ログイン
    if (to.query.ivc != undefined) {
      window.location = "/auth/signup"
      return false
    } else {
      window.location = "/auth/signin";
      return false;
    }
  }
})
export default router
